import React from 'react';
import { useContactNameAffixSuggestionsQuery } from './NameAffixDatalists.graphql.generated';
import { NAME_PREFIX_DATALIST_ID, NAME_SUFFIX_DATALIST_ID } from './NameAffixDatalists.constants';

type NameAffixDatalistsProps = Readonly<{
  eventId: string;
  /**
   * Capability token for the public guest contact collector — lets the query
   * resolve without a session. Omitted in admin surfaces, where the
   * logged-in event admin authorizes the query instead.
   */
  contactCollectionId?: string;
}>;

/**
 * Renders the <datalist> elements backing the Title/Suffix inputs in ContactInfo.
 * Rendered once at the Form level — datalist ids must be unique in the document,
 * while every ContactInfo instance (one per household member) points its inputs
 * at these ids via the `list` attribute.
 *
 * Suggestions are resolved per event locale and are a convenience only — any
 * free-text value is accepted on write.
 */
export const NameAffixDatalists: React.FC<NameAffixDatalistsProps> = ({ eventId, contactCollectionId }) => {
  const { data } = useContactNameAffixSuggestionsQuery({
    variables: { eventId, contactCollectionId },
    batchMode: 'fast',
    ssr: false,
  });

  const suggestions = data?.contactNameAffixSuggestions;

  return (
    <>
      <datalist id={NAME_PREFIX_DATALIST_ID}>
        {suggestions?.prefixes.map((prefix, i) => (
          <option
            key={`${prefix}-${i}`}
            value={prefix}
          />
        ))}
      </datalist>
      <datalist id={NAME_SUFFIX_DATALIST_ID}>
        {suggestions?.suffixes.map((suffix, i) => (
          <option
            key={`${suffix}-${i}`}
            value={suffix}
          />
        ))}
      </datalist>
    </>
  );
};
